import React, { useContext, useEffect, useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { Link, useParams } from "react-router";
import MainHeader from "../../Components/Header/MainHeader";
import { BASE_URL_API } from "../../References/URLs";
import AuthContext from "../../Store/AuthContext";
import styles from "./Cart.module.css";
import { debounce } from "lodash";


const Cart = () => {
    const { storeKey } = useParams();
    const [cartItems, setCartItems] = useState([]);
    const authCtx = useContext(AuthContext);
    const isLoggedIn = authCtx.isLoggedIn;
    const loginData = JSON.parse(authCtx.loginData);
    const [isUpdating, setIsUpdating] = useState(false)

    const getCartItems = async () => {
        const response = await fetch(BASE_URL_API + "getCartItems", {
            method: "POST",
            body: JSON.stringify({
                token: authCtx.token,
                userIdentifier: loginData.userIdentifier,
            }),
        });

        if (!response.ok) {
            console.log("Server Error");
        } else {
            const data = await response.json();
            if (data.status === "success") {
                setCartItems(data.response);
            } else {
                if (data.message === "token Expired, please login again!") {
                    authCtx.logout();
                } else {
                    setCartItems([]);
                }
            }
        }
    };

    const updateCart = async (k, direction) => {
        setIsUpdating(true);

        const updateCartResponse = await fetch(BASE_URL_API + "updateCart",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    cartItemIdentifier : k,
                    direction: direction
                }),
            });

        if (!updateCartResponse.ok) {
            console.log("Something went wrong: Server Error");
        } else {
            const updateCartRespo = await updateCartResponse.json();
            if (updateCartRespo.status === "success") {
                getCartItems(); // Refresh cart items
            } else {
                console.log(updateCartRespo.message);
            }
        }
        setIsUpdating(false);
    };

    const handleIncrease = (k) => {
        updateCart(k, 'increase');
    };

    const handleDecrease = (k) => {
        updateCart(k, 'decrease')
    };

    const handleRemoveItem = async (id) => {
        // setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
        const removeCartItemResponse = await fetch(BASE_URL_API + "removeCartItem",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    cartItemIdentifier: id
                })
            });

        if (!removeCartItemResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const removeCartItemRespo = await removeCartItemResponse.json()
            if (removeCartItemRespo.status === "success") {
                getCartItems()

            } else {
                if (removeCartItemRespo.message === "token Expired, please login again!") {
                    authCtx.logout()
                } else {

                }
            }
        }
    };

    const calculateTotal = () => {
        return cartItems.reduce((total, item) => total + item.mrp * item.quantity, 0).toFixed(2);
    };

    useEffect(() => {
        if (isLoggedIn) {
            getCartItems();
        }
    }, [isLoggedIn]);

    console.log(cartItems)


    const handleQuantityChange = (quantity, cartItemIdentifier) => {
        setCartItems((prevCartItems) =>
            prevCartItems.map((item) =>
                item.cartItemIdentifier === cartItemIdentifier
                    ? { ...item, quantity }
                    : item
            )
        );

        debounceUpdateQuantityHandler(quantity, cartItemIdentifier);
    };

    const debounceUpdateQuantityHandler = debounce(async (quantity, cartItemIdentifier) => {
        try {
            const payload = { token : authCtx.token, cartItemIdentifier, quantity };
            const response = await fetch(BASE_URL_API + 'updateItemQuantity', 
            {
                method: 'POST',
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.message || "Failed to update the cart item.");
            }
            if(result.status!=="success") {

            }
            console.log(result)
        } catch (error) {
            console.error("Error updating quantity:", error.message);
        }
    }, 500);

     // Clean up debounce on component unmount
     useEffect(() => {
        return () => {
            debounceUpdateQuantityHandler.cancel();
        };
    }, []);



    const updateQuantityHandler = async (quantity, cartItemIdentifier) => {
        try {
            // 1. Validate input
            if (quantity === 0) {
                alert("Quantity must be at least 1.");
                return;
            }
            handleQuantityChange(quantity, cartItemIdentifier)
        } catch (error) {
            // 6. Handle errors
            console.error("Error updating quantity:", error.message);
            alert("Unable to update the cart item. Please try again later.");
        }
    };


    return (
        <div>
            <MainHeader cartItems={cartItems} />
            <div className={styles.container}>
                <div className={styles.items}>
                    {cartItems.length > 0 ? (
                        cartItems.map((item) => (
                            <div key={item.productIdentifier} className={styles.item}>
                                <img src={item.productThumbnail} alt={item.name} className={styles.image} />
                                <div className={styles.details}>
                                    <div className={styles.name}>{item?.productTitle}</div>
                                    <div className={styles.price}>₹{item?.mrp}</div>
                                    <div className={styles.quantityAndRemove}>
                                        <div className={styles.quantity}>
                                            <button
                                                onClick={() =>
                                                    handleDecrease(item?.cartItemIdentifier)
                                                }
                                                className={styles.quantityBtn}
                                            >
                                                <FaMinus size={14} />
                                            </button>
                                            <input
                                                type="number"
                                                value={item.quantity}
                                                onChange={(e) => updateQuantityHandler(e.target.value, item?.cartItemIdentifier)}
                                                className={styles.quantityInput}
                                            />
                                            <button
                                                onClick={() =>
                                                    handleIncrease(item?.cartItemIdentifier)
                                                }
                                                className={styles.quantityBtn}
                                            >
                                                <FaPlus size={14} />
                                            </button>
                                        </div>
                                        <button
                                            onClick={() => handleRemoveItem(item.cartItemIdentifier)}
                                            className={styles.removeBtn}
                                        >
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className={styles.empty}>Your cart is empty.</p>
                    )}
                </div>
                <div className={styles.summary}>
                    <div className={styles.summaryContainer}>
                        <div className={styles.orderSummaryTxt} >Order Summary</div>
                        <div className={styles.osTotalWrapper} >
                            <div>Total</div>
                            <div>
                                ₹{calculateTotal()}
                            </div>
                        </div>
                        <Link to={`/${storeKey}/checkout`}>
                            <div
                                className={styles.checkoutBtn}
                            >
                                Proceed to Checkout
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;
